import React, { useState } from 'react'
import { Button, Heading, Paragraph } from '@health-zelas/delta'
import {
  FaRegClone as CopyIcon,
  FaWhatsapp as WhatsappIcon
} from 'react-icons/fa'

import DesktopDownIcon from '../../../../images/icons/desktop-down-icon.svg'

import * as S from './ShareResult.styles'

export const ShareResult = ({ hash }: { hash: string }) => {
  const [copied, setCopied] = useState(false)
  const copyToClipboard = () => {
    navigator.clipboard.writeText(hash)
    setCopied(true)
  }
  return (
    <S.Container>
      <img src={DesktopDownIcon} alt="Ícone de Desktop" width={40} height={40} />

      <Heading
        as="h2"
        weight="semibold"
        css={{
          marginBottom: '$nano',
          marginTop: '$sm'
        }}
      >
        Salve o resultado da simulação!
      </Heading>

      <Paragraph size="sm">
        Você também vai receber essa simulação por e-mail.
      </Paragraph>

      <S.ButtonGroup>
        <Button
          as="a"
          href={`https://api.whatsapp.com/send?text=Confira minha simulação no Zelas! ${hash}`}
          id="button-share-whatsapp"
          target="_blank"
          outlined
          css={{ svg: { pointerEvents: 'none' } }}
        >
          <WhatsappIcon size={20} />
          Envie por whatsapp
        </Button>

        <Button
          type="button"
          id="button-clipboard-result"
          onClick={copyToClipboard}
          outlined
          css={{ svg: { pointerEvents: 'none' } }}
        >
          <CopyIcon size={20} />
          {copied ? 'Link copiado!' : 'Copie o link'}
        </Button>
      </S.ButtonGroup>
    </S.Container>
  )
}
